import React from "react";

const QuantityOption = ({
  quantity,
  pricebreak,
  basePrice,
  initialPrice,
  selectedQuantity,
  handleUpdateQuantity,
  handleUpdateSavings,
  handleCloseDropdown,
}) => {
  const savings = Math.floor(
      ((initialPrice - pricebreak) / initialPrice) * 100,
    ),
    originalPrice = (initialPrice * quantity).toFixed(2),
    currentPrice = (pricebreak * quantity).toFixed(2);

  const onUpdateQuantity = () => {
    handleUpdateQuantity(quantity);
    handleUpdateSavings(savings);
    handleCloseDropdown();
  };

  return (
    <div
      className={`pricebreak__option ${selectedQuantity === quantity ? "selected" : ""}`}
      onClick={onUpdateQuantity}
    >
      <div className="pricebreak__amount">{quantity}</div>

      {savings <= 0 ? (
        <div className="pricebreak__price">${currentPrice}</div>
      ) : (
        <div className="pricebreak__price">
          <span className="pricebreak__crossout">${originalPrice}</span>
          <span className="pricebreak__savings">
            &nbsp;&nbsp;${currentPrice}
          </span>
        </div>
      )}
    </div>
  );
};

export default QuantityOption;
